import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'components/_shared/Icon';
import { Divider } from 'components/_shared/Divider';

import {
  FlexWrap,
  GreenhouseWrapper,
  Title,
  GreenhouseSelect
} from '../GreenhouseList/GreenhouseList.styles';
import { selectZone, useZoneActions } from 'state';

export const ZoneList = () => {
  const { getZones, setSelectedZone } = useZoneActions();
  const { zones, selectedZone } = useSelector(selectZone);

  useEffect(() => {
    if (!zones.length) getZones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <GreenhouseWrapper>
        <FlexWrap>
          <Icon>{'Polygon'}</Icon>
          <Title>Zone</Title>
        </FlexWrap>
        <GreenhouseSelect
          items={zones.map(x => ({ name: x.name, value: x.id }))}
          placeholder='Select zone'
          onSelect={({ value }) => setSelectedZone(value)}
          value={zones.find(x => x.id === selectedZone)?.id}
        />
      </GreenhouseWrapper>
      <Divider />
    </>
  );
};
